import { Plus } from "lucide-react";

const RESULTS = ["pending", "win", "loss", "push"];

function resultBtnClass(isActive, r) {
  if (!isActive) return "border-zinc-800 text-zinc-400 hover:border-zinc-600";
  if (r === "win") return "bg-[#00D4FF] text-black border-[#00D4FF]";
  if (r === "loss") return "bg-red-500 text-black border-red-500";
  return "bg-zinc-700 text-white border-zinc-700";
}

export default function BetForm({ form, setForm, onSubmit }) {
  const update = (patch) => setForm({ ...form, ...patch });

  return (
    <form
      onSubmit={onSubmit}
      className="lg:col-span-4 border border-zinc-800 p-6 space-y-4 bg-zinc-950/60 h-fit"
    >
      <div className="overline">LOG NEW BET</div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="overline block mb-1">SPORT</label>
          <select
            value={form.sport}
            onChange={(e) => update({ sport: e.target.value })}
            data-testid="bet-sport"
            className="w-full bg-transparent border border-zinc-800 px-2 py-2 mono text-sm focus:outline-none focus:border-[#00D4FF]"
          >
            <option value="mlb">MLB</option>
            <option value="nba">NBA</option>
            <option value="nhl">NHL</option>
            <option value="nfl">NFL</option>
            <option value="mma">MMA</option>
          </select>
        </div>
        <div>
          <label className="overline block mb-1">VARIANT</label>
          <select
            value={form.variant}
            onChange={(e) => update({ variant: e.target.value })}
            data-testid="bet-variant"
            className="w-full bg-transparent border border-zinc-800 px-2 py-2 mono text-sm focus:outline-none focus:border-[#00D4FF]"
          >
            <option value="classic">Classic</option>
            <option value="grand">Grand</option>
            <option value="mini">Mini</option>
            <option value="anti">Anti</option>
            <option value="dalembert">D'Alembert</option>
          </select>
        </div>
      </div>

      <div>
        <label className="overline block mb-1">MATCHUP</label>
        <input
          value={form.matchup}
          onChange={(e) => update({ matchup: e.target.value })}
          data-testid="bet-matchup"
          className="w-full bg-transparent border border-zinc-800 px-3 py-2 mono text-sm focus:outline-none focus:border-[#00D4FF]"
          placeholder="Yankees @ Red Sox"
        />
      </div>

      <div>
        <label className="overline block mb-1">PICK</label>
        <input
          required
          value={form.pick}
          onChange={(e) => update({ pick: e.target.value })}
          data-testid="bet-pick"
          className="w-full bg-transparent border border-zinc-800 px-3 py-2 mono text-sm focus:outline-none focus:border-[#00D4FF]"
          placeholder="Yankees ML"
        />
      </div>

      <div className="grid grid-cols-3 gap-3">
        <div>
          <label className="overline block mb-1">STAKE</label>
          <input
            required
            type="number"
            min={1}
            value={form.stake}
            onChange={(e) => update({ stake: e.target.value })}
            data-testid="bet-stake"
            className="w-full bg-transparent border border-zinc-800 px-2 py-2 mono text-sm focus:outline-none focus:border-[#00D4FF]"
          />
        </div>
        <div>
          <label className="overline block mb-1">ODDS</label>
          <input
            type="number"
            value={form.american_odds}
            onChange={(e) => update({ american_odds: e.target.value })}
            data-testid="bet-odds"
            className="w-full bg-transparent border border-zinc-800 px-2 py-2 mono text-sm focus:outline-none focus:border-[#00D4FF]"
          />
        </div>
        <div>
          <label className="overline block mb-1">STEP</label>
          <input
            type="number"
            min={1}
            value={form.step}
            onChange={(e) => update({ step: e.target.value })}
            data-testid="bet-step"
            className="w-full bg-transparent border border-zinc-800 px-2 py-2 mono text-sm focus:outline-none focus:border-[#00D4FF]"
          />
        </div>
      </div>

      <div>
        <label className="overline block mb-1">RESULT</label>
        <div className="grid grid-cols-4 gap-2">
          {RESULTS.map((r) => (
            <button
              key={r}
              type="button"
              onClick={() => update({ result: r })}
              data-testid={`bet-result-${r}`}
              className={`py-2 font-mono text-xs uppercase tracking-wider border ${resultBtnClass(
                form.result === r,
                r
              )}`}
            >
              {r}
            </button>
          ))}
        </div>
      </div>

      <button
        type="submit"
        data-testid="bet-submit"
        className="w-full py-3 bg-[#00D4FF] text-black font-mono uppercase tracking-widest text-xs hover:brightness-110 flex items-center justify-center gap-2"
      >
        <Plus size={14} strokeWidth={1.5} /> Log Bet
      </button>
    </form>
  );
}
